import React, { Fragment } from "react";
import PropTypes from "prop-types";
import EncabezadoComponent from "../../../utilerias/encabezado";
import QUienEsomponent from "../quienEs";
import VideoComponent from "../video";
import $ from "jquery";
import "./styles.css";

const OverlayComponent = (props) => {
  const efectoAncla = (id) => {
    $(document).ready(function ($) {
      const quitarClase = document.getElementsByClassName("activar-icono");
      if (quitarClase.length > 0) {
        quitarClase[0].className = "";
      }
      const añadirClase = document.getElementById(id + "-icono");
      añadirClase.className = "activar-icono";

      const target = $("#" + id);
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
      }
    });
  };
  const quitarFiltro = (status) => {
    const video = document.getElementsByTagName("video");
    if (status === true) {
      video[0].style.filter = "blur(0px)";
      video[0].style.zIndex = "1200";
      $("video").prop('muted', false);
      document.getElementById("texto-1").style.opacity = "0";
      document.getElementById("texto-2").style.opacity = "0";
    } else {
      video[0].style.filter = "blur(22px)";
      video[0].style.zIndex = "0";
      $("video").prop('muted', true);
      document.getElementById("texto-1").style.opacity = "1";
      document.getElementById("texto-2").style.opacity = "1";
    }
  };
  const scrollPosition = () => {
    $(window).scroll(function (event) {
      const scrollTop = $(window).scrollTop();
      const quitarClase = document.getElementsByClassName("activar-icono");
      const añadirClaseQuines = document.getElementById("quienes-somos-icono");
      const añadirClaseVideo = document.getElementById("video-icono");

      if (quitarClase.length > 0) {
        quitarClase[0].className = "";
      }

      if (scrollTop > 600 && añadirClaseQuines) {
        añadirClaseQuines.className = "activar-icono";
      } else if (añadirClaseVideo) {
        añadirClaseVideo.className = "activar-icono";
      }
    });
  };
  scrollPosition();
  return (
    <Fragment>
      <div className="overlay-video">
        <div className="encabezado">
          <EncabezadoComponent
            componente={props.componente}
            select={false}
          ></EncabezadoComponent>
        </div>
        <div className="nav-nosotrso">
          <img
            src="/assets/fuentes/iconos/IconoVideo.svg"
            alt=""
            onClick={() => efectoAncla("video")}
            id="video-icono"
            className="activar-icono"
          />
          <img
            src="/assets/fuentes/iconos/IconoEquipo.svg"
            alt=""
            onClick={() => efectoAncla("quienes-somos")}
            id="quienes-somos-icono"
          />
        </div>
        <div id="video" className="background-color-video">
          <VideoComponent
            cambiarIdioma={props.cambiarIdioma}
            evento={quitarFiltro}
          ></VideoComponent>
        </div>
        <div id="quienes-somos" className="background-color-quien-es">
          <QUienEsomponent
            cambiarIdioma={props.cambiarIdioma}
          ></QUienEsomponent>
        </div>
      </div>
    </Fragment>
  );
};

OverlayComponent.propTypes = {
  hover: PropTypes.func,
  array: PropTypes.array,
  componente: PropTypes.string,
  cambiarIdioma: PropTypes.bool,
};

export default OverlayComponent;
